import { Component, ViewEncapsulation, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppStore, getAppSelection } from '@alfresco/aca-shared/store';
import { take } from 'rxjs/operators';
import { CarlisleContentManagementService } from '../../services/carlisle-content-management.service';

@Component({
  selector: 'app-copy-node-action',
  template: `
    <button
      *ngIf="data.iconButton"
      mat-icon-button
      [attr.aria-label]="(data.title ?? 'Copy') | translate"
      [attr.title]="(data.title ?? 'Copy') | translate"
      (click)="onClick()"
    >
      <mat-icon>forward</mat-icon>
    </button>

    <button *ngIf="data.menuButton" mat-menu-item (click)="onClick()">
      <mat-icon>forward</mat-icon>
      <span>{{ (data.title ?? 'Copy') | translate }}</span>
    </button>
  `,
  encapsulation: ViewEncapsulation.None,
  host: { class: 'app-copy-node-action' }
})
export class CopyNodeActionComponent {
  @Input()
  data!: { title?: string; menuButton?: boolean; iconButton?: boolean; };

  constructor(private store: Store<AppStore>, private carlisleContentService: CarlisleContentManagementService) {}

  onClick() {
    this.store
      .select(getAppSelection)
      .pipe(take(1))
      .subscribe((selection) => {
        if(selection.file)
          this.carlisleContentService.copyJobDocument(selection.file);
      });
  }
}
